import { Button, message } from "antd";
import { DownloadOutlined } from "@ant-design/icons";
import * as ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import dayjs from "dayjs";

export default function ExportResumenProyectosButton({ data }) {

  const exportar = async () => {

    if (!data || data.length === 0) {
      message.warning("No hay datos para exportar");
      return;
    }

    const workbook = new ExcelJS.Workbook();
    const sheet = workbook.addWorksheet("Resumen por proyecto");

    // ---------- TITULO ----------
    sheet.mergeCells("A1:D1");

    const title = sheet.getCell("A1");
    title.value = "RESUMEN DE ENTREGAS POR PROYECTO";
    title.font = { size: 18, bold: true, color: { argb: "FFFFFFFF" } };

    title.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FF042956" }
    };

    title.alignment = {
      vertical: "middle",
      horizontal: "center"
    };

    sheet.getRow(1).height = 30;

    // ---------- INFO REPORTE ----------
    sheet.mergeCells("A2:D2");

    const info = sheet.getCell("A2");
    info.value = `Fecha de generación: ${dayjs().format("DD/MM/YYYY HH:mm")}`;
    info.alignment = { horizontal: "center" };

    sheet.addRow([]);

    // ---------- HEADERS ----------
    const headers = ["Proyecto", "Actas", "Productos en stock", "Alertas"];

    const headerRow = sheet.addRow(headers);

    headerRow.eachCell((cell) => {

      cell.font = {
        bold: true,
        color: { argb: "FFFFFFFF" }
      };

      cell.alignment = {
        vertical: "middle",
        horizontal: "center"
      };

      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FF1F4E78" }
      };

      cell.border = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" }
      };

    });

    // ---------- FILAS ----------
    data.forEach((p) => {

      const row = sheet.addRow([
        p.proyecto,
        Number(p.actas) || 0,
        Number(p.productos_stock) || 0,
        Number(p.alertas) || 0
      ]);

      row.eachCell((cell) => {

        cell.border = {
          top: { style: "thin" },
          left: { style: "thin" },
          bottom: { style: "thin" },
          right: { style: "thin" }
        };

        cell.alignment = {
          vertical: "middle",
          wrapText: true
        };

      });

    });

    // ---------- ANCHO COLUMNAS ----------
    sheet.columns = [
      { width: 50 },
      { width: 14 },
      { width: 20 },
      { width: 14 }
    ];

    // ---------- ALINEACION NUMERICA ----------
    ["B", "C", "D"].forEach((col) => {
      sheet.getColumn(col).alignment = { horizontal: "center", vertical: "middle" };
    });

    // ---------- CONGELAR HEADERS ----------
    sheet.views = [
      { state: "frozen", ySplit: 4 }
    ];

    // ---------- DESCARGA ----------
    const buffer = await workbook.xlsx.writeBuffer();

    const blob = new Blob([buffer], {
      type:
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    });

    saveAs(blob, `resumen_proyectos_${dayjs().format("YYYYMMDD_HHmm")}.xlsx`);

  };

  return (
    <Button
      icon={<DownloadOutlined />}
      onClick={exportar}
      type="primary"
      style={{
        background: "#042956",
        borderColor: "#042956"
      }}
    >
      Exportar a Excel
    </Button>
  );
}
